import { get, post, put } from "../Config";


export function SearchCustomer({ params = {} }) {
  return get({ url: `/api/impact-admin/v1/searchCustomer`, params });
}